import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';
import { LegalDateTimeService } from 'src/app/services/legal-datetime.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { ChartComponent, ChartTheme, ILoadedEventArgs, IPointEventArgs } from '@syncfusion/ej2-angular-charts';

@Component({
  selector: 'app-metric-chart-multi-series-staff-data',
  templateUrl: './metric-chart-multi-series-staff-data.component.html',
  styleUrls: ['./metric-chart-multi-series-staff-data.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService]

})
export class MetricChartMultiSeriesStaffDataComponent implements OnInit {


  // public data: Object[] = [];
  
  @Input() sent_data?: any; // not used

  // public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid2') public grid2: GridComponent;
  @ViewChild('grid3') public grid3: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;

  public groupOptions: GroupSettingsModel;
  // public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;


  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both



     // setup as observable?
     @Input() item_id?: any; // impliments on changes.
     @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full

       // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;


    public title?: string;

    search_results: any;
  woo_orders: any;
  graph_data: Object[];
  search_results_clone_START: any;
  moviesByRating: any[];
  user_login_count: number;
  user_logout: any[];
  user_logout_count: number;
  user_forced_logout_ON: any[];
  user_forced_logout_ON_count: number;
  user_forced_logout_OFF: any[];
  user_forced_logout_OFF_count: number;
  log_types_mapped_numbers: any[];
  log_types_mapped_labels: any[];
  Chart2_title: string;

  chartData_client: { log_type_name: string; sum: number; color: string; }[];
  chartData_agent: { log_type_name: string; sum: number; color: string; }[];
  chartData_staff: { log_type_name: string; sum: number; color: string; }[];


  Chart2_users_data: any;
  search_results_START: any;
  search_results_clone: any;
  
  Chart3_title: string;
  Chart3_marker: { visible: boolean; width: number; height: number; shape: string; };
  Chart3_tooltip: { enable: boolean; template: any; };
  Chart3_tooltipTemplate: any;
  Chart3_all_data: { log_type_name: any; sum: any; color: string; created_date: Date; }[];



  Chart4_title: string;
  Chart4_marker: { visible: boolean; width: number; height: number; shape: string; };
  Chart4_tooltip: { enable: boolean; template: any; };
  Chart4_tooltipTemplate: any;
  Chart4_all_data: { log_type_name: any; sum: any; color: string; created_date: Date; }[];





  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };

  today = new Date(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison

woo_products: any;
sessionUserId: any;
sessionUsername: any;
all_router_details: string;
sessionBrandId: any;
initialPage: { pageSize: number; };
woo_products_object: any;
public page_collection = [];
sessionUserName: string;
sessionUserLevel: number;
sessionUserFullName: string;
sessionUserFirstName: string;



    //syncfusion charts
    @ViewChild('chart')
    public chart: ChartComponent;
    public primaryXAxis: Object;
  public chartData: Object[];
  public marker: Object;
  public tooltip: Object;
  public Chart2_marker: Object;
  public Chart2_tooltip: Object;
  
  public primaryYAxis: Object;
  public cornerRadius: Object;
  public chartArea: Object;
  public animation: Object;
  public pointColorMapping: string;
  system_log_types: Object;
  public pointClick(args: IPointEventArgs): void {
    document.getElementById("lbl").innerText = "Type : "+ args.point.x + "\nSum : "+ args.point.y  + "\nY : "+ args.series.name;
  };
  public pointClick_meta(args: IPointEventArgs): void {
    document.getElementById("lbl_meta").innerText = "Type : "+ args.point.x + "\nSum : "+ args.point.y  + "\nY : "+ args.series.name;
  };
  
  primaryXAxis_DateTimeCategory = {
    // valueType: 'DateTimeCategory'
    // valueType: 'Category'
    valueType: 'DateTime'
    
  };
  
  public tooltipTemplate: string =
  "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";
  
  public Chart2_tooltipTemplate: string =
  "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";
  
  
  
  
    // chart: c3.ChartAPI; -- Disable if using syncfusion charts
          // @ViewChild('chart') chart: c3.ChartAPI;
          chart_guage: c3.ChartAPI; // @ViewChild('chart_guage') 
  
  
  
           // toggle elements
          //  isShow = true;
          isShow_chart1 = false;
          isShow_chart2 = false;
          isShow_chart4 = false; // new staff metrics perspective.
          
          isShow_chart1_meta = false;
          isShow_chart2_meta = false; // user investigation as default
          isShow_chart3_meta = false; // user investigation as default


  constructor(
        // private productService: WoocommerceProductsService,
    // private orderService: WoocommerceOrderService,
    private http: HttpClient, private router: Router,
      private route: ActivatedRoute, private _demoService: DemoService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private modalService: BsModalService,
     public toastr: HotToastService,
     vcr: ViewContainerRef,
     private _mysqlService: MysqlService,
     public legalDate: LegalDateTimeService,
  ) { 


 // Grid Options
          // this.toolbarOptions = [];
          // Setup Grid
          this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
            tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
            ];
            // this.toolbar = [
            // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
  
  
            this.initialPage = { pageSize: 100 };
            this.filterOptions = {
            type: 'Menu'
            };
  
            // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
            this.groupOptions = { }; // sets auto grouping for the grid
  
            this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
            this.dateFormat = 'dd/MM/yyyy hh:mm a';
  
            // this.filter = { params: { format: this.dateFormat } };
            // this.sortOptions = { columns: [ ] };
  
            //checkbox selection options
            // this.selectionOptions = { checkboxMode: 'ResetOnRowClick'}; // type: 'Multiple', mode: 'Both
            this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 
  
            this.searchOptions = {  };
            // this.grid.searchSettings.key = '';
  
            
  
            // load some custom ngx-woo api search options
            for(let i = 1; i<=99 ; i++) {
            this.page_collection.push(`${i}`);
            }
  
        // this.generateChart();


  }

  ngOnInit(): void {

    this.systemLogNumbers(this.item_data)

//     this.chartData = [
//       { country: "USA", gold: 50, silver: 70, bronze: 45 },
//       { country: "China", gold: 40, silver: 60, bronze: 55 },
//       { country: "Japan", gold: 70, silver: 60, bronze: 50 },
//       { country: "Australia", gold: 60, silver: 56, bronze: 40 },
//       { country: "France", gold: 50, silver: 45, bronze: 35 },
//       { country: "Germany", gold: 40, silver: 30, bronze: 22 },
//       { country: "Italy", gold: 40, silver: 35, bronze: 37 },
//       { country: "Sweden", gold: 30, silver: 25, bronze: 27 }
// ];



//   this.chartData = [
//     { name: "Sally", user_login: 50, user_logout: 70, log_type_name: 45 },
//     { name: "Bukk", user_login: 100, user_logout: 22, log_type_name: 3 },
//     // { name: "Japan", gold: 70, silver: 60, bronze: 50 },
//     // { name: "Australia", gold: 60, silver: 56, bronze: 40 },
//     // { name: "France", gold: 50, silver: 45, bronze: 35 },
//     // { name: "Germany", gold: 40, silver: 30, bronze: 22 },
//     // { name: "Italy", gold: 40, silver: 35, bronze: 37 },
//     // { name: "Sweden", gold: 30, silver: 25, bronze: 27 }
// ];



// this.primaryXAxis = {
//     valueType: 'Category',
//     title: 'Action'
// };
// this.primaryYAxis = {
//     minimum: 0, maximum: 80,
//     interval: 20, title: 'Counts/period'
// };
// this.title = 'Staff Actions';


  }



  ngOnChanges(changes) {

    this.getSystemLogTypes();


this.woo_orders = this.item_data; // sets the data regardless.

       if (changes.item_id) {
         // deal with asynchronous Observable result
         this.item_id = changes.item_id.currentValue;
       }


       if (changes.item_data) {
         // deal with asynchronous Observable result
         // this.getJob(this.job_id);
       // console.log('On changes Sent Action List Id:' + this.action_list_id);
       // this.generateChart();

         // this commnad dynamically loads data int the fhart
       // this.chart.load({
       //   columns: [
       //     ['data4', 300, 100, 250, 150, 300, 150, 500],
       //     ['data5', 100, 200, 150, 50, 100, 250]
       //   ]
       // });

  

       this.woo_orders = changes.item_data.currentValue;

                

                               // a simple pause to load the log_typ
      // if for meta or live data.
      
        setTimeout(() => {  
      
        this.systemLogNumbers(this.woo_orders)
         // New seperate
         // this.load_Chart1(this.woo_orders)


       }, 1000);
                      


     //  this.setupOrderCounts(this.woo_orders);
       // this.getActionList(this.action_list_id);
       // this.loadashExamples(this.woo_orders);

       // console.log('Item Data: ' + JSON.stringify(this.item_data));
       // console.log('Woo Orders: ' + JSON.stringify(this.woo_orders));


// Reload Counds
// this.loadCompletedItemsPercentage(this.total_completed_items_percentage, 'chart_guage', 'Total Complete', '180');
// this.loadCompletedItemsPercentage(this.total_cp_items_completed_percentage, 'total_cp_items_completed', 'CP Completed', '120');
//  this.loadCompletedItemsPercentage(this.total_mail_items_completed_percentage, 'total_mail_items_completed', 'MAIL Completed', '120');
//  this.loadCompletedItemsPercentage(this.total_checkout_mail_items_completed_percentage, 'total_checkout_mail_items_completed', 'Woo Checkout Completed', '250');

       }


     }




  systemLogNumbers(send_data){
 

    // this.search_results = this.woo_orders; // works for meta pass - not direct orders via mysql?
    this.search_results = send_data; // works for meta pass - not direct orders via mysql?
  
  
    this.graph_data = new DataManager(this.search_results as JSON[]).executeLocal(new Query()); // Sets the grid data for the graphs //.take(100)
  
    this.search_results_clone_START = this.woo_orders; // works for meta pass - not direct orders via mysql?
  
  
  
    this.moviesByRating = _.filter(send_data, (movie) => movie.log_type_id > 5);
    this.user_login_count = this.moviesByRating.length;
  
    this.user_logout = _.filter(send_data, (movie) => movie.log_type_id > 30);
    this.user_logout_count = this.user_logout.length;
  
    this.user_forced_logout_ON = _.filter(send_data, (movie) => movie.log_type_id > 28);
    this.user_forced_logout_ON_count = this.user_forced_logout_ON.length;
  
    this.user_forced_logout_OFF = _.filter(send_data, (movie) => movie.log_type_id > 29);
    this.user_forced_logout_OFF_count = this.user_forced_logout_OFF.length;
  
    // let count_of_items =  this.system_log_types.length
    //                   // let newArr = this.payment_item_model.filter((sbi)=>(1===1));
    //                 // let count_of_items = this.payment_item_model.length;
    //                 for(let i=0;i < count_of_items; i++) {
    //                   let log_types_res = this.system_log_types[i];
    //                   // get a count and set a variable or push to array... ???
                      
    //                   // this.lookupInvoiceUpdateInvoice2(this.payment_item_model.myob_id, data);
    //                 }
  let arr =  this.search_results;
  // console.log('System_log_Types' + JSON.stringify(this.system_log_types));
                    const result2 = _.map(
                      _.groupBy(arr, 'log_type_id'),
                     items => ({
                      ...items[0].log_type_id,
                      count: items.length
                     })
                    )
                    
                    console.log('Count Resutl:' + JSON.stringify(result2));
  
  
  
  
   // using the identity method
  let b = _.countBy(arr, 'log_type_name');
  console.log('b: ' + JSON.stringify(b));
  
  let mapped_b_numbers = _.map(b, 'log_type_name');
  let mapped_b_labels = _.map(b, 'count');
  this.log_types_mapped_numbers = mapped_b_numbers;
  this.log_types_mapped_labels = mapped_b_labels;
  
  
  
  
  
  
  
  
  
  // var data = [
  //   {"cat":"IT","company":"Apple", "price":"100.5"},
  //   {"cat":"IT","company":"Apple", "price":"100"},
  //   {"cat":"IT","company":"Google", "price": "100"},
  //   {"cat":"IT","company":"Apple", "price": "100"}
  //  ];
  //  var group = _.groupBy(data, 'company')
  //  var group = _.groupBy(this.search_results, 'log_type_name')
   
  //  var result00 = _.map(_.keys(group), function(e) {
  //    return _.reduce(group[e], function(r, o) {
  //     //  return r.count += +o.log_id, r
  //      return  r
  //   }, {log_type_name: e, sum: group[e].length, color: ""})
  //  })
   
  //  console.log(result00);

  var group = _.groupBy(this.search_results[0], 'log_type_name')
  var result00 = _.map(_.keys(group), function(e) {
    return _.reduce(group[e], function(r, o) {
     //  return r.count += +o.log_id, r
      return  r
   }, 
  //  {log_type_name: e, sum: group[e].length, color: ""})
   {log_type_name: e, sum: group[e].length, color: ""})
  })
  
  console.log(result00);






  
  
  
   let add_clients_data =  this.search_results.filter(function(t) {
    return t.brand_type_id == '3';
    });
    var client_group = _.groupBy(add_clients_data, 'log_type_name')
    var result00_client = _.map(_.keys(client_group), function(e) {
      return _.reduce(client_group[e], function(r, o) {
       //  return r.count += +o.log_id, r
        return  r
     }, 
     {log_type_name: e, sum: client_group[e].length, color: "purple"}
     )
    })
  
    let add_agents_data =  this.search_results.filter(function(t) {
      return t.brand_type_id == '2';
      });
      var agent_group = _.groupBy(add_agents_data, 'log_type_name')
      var result00_agent = _.map(_.keys(agent_group), function(e) {
        return _.reduce(agent_group[e], function(r, o) {
         //  return r.count += +o.log_id, r
          return  r
       }, 
       {log_type_name: e, sum: agent_group[e].length, color: "tomato"}
       )
      })
  
      let add_staff_data =  this.search_results.filter(function(t) {
        return t.brand_type_id == '1';
        });
        var staff_group = _.groupBy(add_staff_data, 'log_type_name')
        var result00_staff = _.map(_.keys(staff_group), function(e) {
          return _.reduce(staff_group[e], function(r, o) {
           //  return r.count += +o.log_id, r
            return  r
         }, 
         {log_type_name: e, sum: staff_group[e].length, color: "DodgerBlue"}
         )
        })
  
  
  
        // let add_Chart2_users_data =  this.search_results.filter(function(t) {
        //   return t.who_created == send_data.who_created;
        //   });
        //   var Chart2_users_group = _.groupBy(add_Chart2_users_data, 'log_type_name')
        //   var result00_Chart2_users = _.map(_.keys(Chart2_users_group), function(e) {
         
        //     return _.reduce(Chart2_users_group[e], function(r, o) {
        //      //  return r.count += +o.log_id, r
        //       return  r
        //    }, 
        //   //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "green"}
        //   // {created_date: Chart2_users_group[e]["created_date"], sum: e , color: "green"}
        //   {created_date: add_Chart2_users_data, sum: e , color: "green"}
   
  
        //    )
        //   })
  
  
          // var Chart2_users_group = _.groupBy(this.search_results, 'log_type_name')
          var Chart2_users_group = this.search_results;
          
          var result00_Chart2_users_group = _.map(_.keys(Chart2_users_group), function(e) {
            return _.reduce(Chart2_users_group[e], function(r, o) {
             //  return r.count += +o.log_id, r
              return r
           },
          //  2023-05-20T12:44:00+1000
          //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
          //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
           {log_type_name: Chart2_users_group[e].created_level, sum: Chart2_users_group[e].length, color: "yellow", created_date: this.legalDate.toAuditDate(Chart2_users_group[e].created_date) ?? new Date(Chart2_users_group[e].created_date)})
          })
  
  
          this.Chart2_title = 'Created Level Vs Time Track'
          this.Chart2_marker = { visible: true, width: 10, height: 10, shape: "Rectangle" };
          this.Chart2_tooltip = {
            enable: true,
            template: this.Chart2_tooltipTemplate
          };
  
  
          // Chart 3 - Events Categories Over Time.
          var Chart3_users_group = this.search_results;
          
          var result00_Chart3_users_group = _.map(_.keys(Chart3_users_group), function(e) {
            return _.reduce(Chart3_users_group[e], function(r, o) {
             //  return r.count += +o.log_id, r
              return r
           },
          //  2023-05-20T12:44:00+1000
          //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
          //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
           {log_type_name: Chart3_users_group[e].log_type_id, sum: Chart3_users_group[e].length, color: "navy", created_date: this.legalDate.toAuditDate(Chart3_users_group[e].created_date) ?? new Date(Chart3_users_group[e].created_date)})
          })
  
  
          this.Chart3_title = 'Log TypeID Vs Time Track'
          this.Chart3_marker = { visible: true, width: 10, height: 10, shape: "Triangle" };
          this.Chart3_tooltip = {
            enable: true,
            template: this.Chart3_tooltipTemplate
          };
  
        this.Chart3_tooltipTemplate = "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";
  
  







          // var Chart2_users_group = _.groupBy(this.search_results, 'log_type_name')
          var Chart4_created_by_full_logs = this.search_results;
          
          var result00_Chart4_created_by_full_logs = _.map(_.keys(Chart4_created_by_full_logs), function(e) {
            return _.reduce(Chart4_created_by_full_logs[e], function(r, o) {
             //  return r.count += +o.log_id, r
              return r
           },
          //  2023-05-20T12:44:00+1000
          //  {log_type_name: e, sum: Chart2_users_group[e].length, color: "", created_date: Chart2_users_group[e].request_time})
          //  {log_type_name: Chart2_users_group[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: Chart2_users_group[e].created_date})
          //  {log_type_name: Chart2_users_group[e].created_level, sum: Chart2_users_group[e].length, color: "yellow", created_date: new Date( Chart2_users_group[e].created_date)})
           {log_type_name: Chart4_created_by_full_logs[e].log_type_name, sum: Chart2_users_group[e].length, color: "yellow", created_date: this.legalDate.toAuditDate(Chart2_users_group[e].created_date) ?? new Date(Chart2_users_group[e].created_date)})
          })
  
  
          this.Chart4_title = 'All Results / Logs Perspective'
          this.Chart4_marker = { visible: true, width: 10, height: 10, shape: "Rectangle" };
          this.Chart4_tooltip = {
            enable: true,
            template: this.Chart4_tooltipTemplate
          };
  
          this.Chart4_tooltipTemplate = "<div id='templateWrap'><table style='width:100%;border: 1px solid black;'><tr><th colspan='2'  bgcolor='#00FFFF'>Female</th></tr><tr><td bgcolor='#00FFFF'>${x}:</td><td bgcolor='#00FFFF'>${y}</td></tr></table></div>";













  
          // Load all charts
  
    this.chartData = result00;
    // this.chartData = this.item_data; // unchanged from search -- full log results 
    this.chartData_client = result00_client;
    this.chartData_agent = result00_agent;
    this.chartData_staff = result00_staff;
    this.Chart2_users_data = result00_Chart2_users_group;
    this.Chart3_all_data = result00_Chart3_users_group;
   
    this.Chart4_all_data  = result00_Chart4_created_by_full_logs


  
  // this.chartData = [
  //   { month: 'Jan', sales: 35 }, { month: 'Feb', sales: 28 },
  //   { month: 'Mar', sales: 34 }, { month: 'Apr', sales: 32 },
  //   { month: 'May', sales: 40 }, { month: 'Jun', sales: 32 },
  //   { month: 'Jul', sales: 35 }, { month: 'Aug', sales: 55 },
  //   { month: 'Sep', sales: 38 }, { month: 'Oct', sales: 30 },
  //   { month: 'Nov', sales: 25 }, { month: 'Dec', sales: 32 }
  // ];
  this.primaryXAxis = {
    valueType: 'Category',
    title: 'Event Types'
  };
  // this.title = 'All Log Events';
  this.tooltip = { enable: true };
  this.marker = { visible: true, width: 10, height: 10 };
  this.title = 'Investigation Events: 1975-2010';
  this.chartArea = {
    border: {
        width: 0
    }
  };
  this.cornerRadius = {
    topLeft: 10, topRight: 10
  };
  this.pointColorMapping = "color";
  this.animation = { enable: true};
  
  
  
  
  
  var countBy = (obj, func) => {
    var counts = {};
    var arr = Object.keys(obj);
    arr.forEach((sourceKey, i, arr) => {
        var el = obj[sourceKey];
        var key = func.call(obj, el, sourceKey, obj);
        counts[key] = counts[key] === undefined ? 1 : counts[key] += 1;
    });
    return counts;
  };
  
  // let arr = [{
  //       username: 'john',
  //       score: 37
  //   }, {
  //       username: 'jake',
  //       score: 67
  //   }, {
  //       username: 'bill',
  //       score: 20
  //   }
  // ];
  
  console.log(countBy(arr, function (el) {
        return el.score >= 65 ? 'pass' : 'fail';
    }));
  
  
  
  
    var result = this.search_results.reduce(function(r, o) {
      if (r[o.log_type_id]){
          ++r[o.log_type_id].count;
          // r[o.company].price += Number(o.price);
      } else {
          // r[o.company] = {count: 1, price: Number(o.price)};
      }
      return r;
  }, {});
  
  console.log('r' + JSON.stringify(result));
  
  }
  


  getSystemLogTypes() {
    this._demoService.getSystemLogTypes().subscribe(
       data2 => { this.system_log_types = data2;
        // console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }

}
